import React, { FC } from 'react'
import { Box, Text, VStack, Button } from '@chakra-ui/react'
import { FiSearch, FiUsers } from 'react-icons/fi'

interface EmptyStateProps {
  hasSearchTerm: boolean
  hasTierFilter: boolean
  onClearFilters: () => void
}

const EmptyState: FC<EmptyStateProps> = ({ hasSearchTerm, hasTierFilter, onClearFilters }) => {
  const getTitle = () => {
    if (hasSearchTerm && hasTierFilter) {
      return 'No users found matching your search and filter criteria'
    } else if (hasSearchTerm) {
      return 'No users found matching your search'
    } else if (hasTierFilter) {
      return 'No users found with the selected tier'
    }
    return 'No users found'
  }

  const getDescription = () => {
    if (hasSearchTerm || hasTierFilter) {
      return "Try adjusting your search terms or filters to find what you're looking for."
    }
    return 'There are no users in the system yet.'
  }

  const getIcon = () => {
    if (hasSearchTerm || hasTierFilter) {
      return <FiSearch size={48} color="#A7A7A7" />
    }
    return <FiUsers size={48} color="#A7A7A7" />
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={16}
      px={8}
      textAlign="center"
    >
      <VStack spacing={4}>
        {getIcon()}
        <Text fontSize="lg" fontWeight="600" color="#585858">
          {getTitle()}
        </Text>
        <Text fontSize="sm" color="#A7A7A7" maxW="400px">
          {getDescription()}
        </Text>
        {(hasSearchTerm || hasTierFilter) && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClearFilters}
            color="#3182CE"
            borderColor="#3182CE"
            _hover={{
              bg: '#3182CE',
              color: 'white',
            }}
          >
            Clear filters
          </Button>
        )}
      </VStack>
    </Box>
  )
}

export default EmptyState
